import { GetChildrenFilterKey } from 'types';

export const childFilterFields: Record<GetChildrenFilterKey, GetChildrenFilterKey> = {
    status: 'status',
    groupIds: 'groupIds',
    contractValid: 'contractValid',
};
